/* Dependencies
 ----------------------------------------------------------*/
import {Application} from "wrapper6";

/* Vendor
 ----------------------------------------------------------*/


/* Setup
 ----------------------------------------------------------*/
var app = window.app = new Application(window.options || {});

/* Services
 ----------------------------------------------------------*/


/* Register services
 ----------------------------------------------------------*/

/* Modules
 ----------------------------------------------------------*/
import Navigation from "../modules/_navigation.js";
import ObjectFit from "../modules/_object-fit.js";
import Print from "../modules/_print.js";
import Shop from "../modules/_shop.js";
import Modalbox from "../modules/_modalbox.js";
import Quote from "../modules/_quote.js";
import Employees from "../modules/_employees.js";
import Tickets from "../modules/_tickets.js";
import FilteringActivites from "../modules/_filtering_activities";
import Filters from "../modules/_filters.js";
import VideoModal from "../modules/_video-modal.js";
import ImageSlider from "../modules/_image-slider.js";
import InfoboxesGrid from "../modules/_infoboxes-grid.js";
import LoadActivities from "../modules/_load-activities.js";
import NumbersLine from "../modules/_numbers-line.js";
import MapPinSlider from '../modules/_map-pins-slider.js'
import Accordion from "../modules/_accordion";
import MorningPopup from "../modules/_morning-popup";
import Tooltips from '../modules/_tooltips.js'


/* Register modules
 ----------------------------------------------------------*/
app.use(Navigation);
app.use(ObjectFit);
app.use(Print);
app.use(Shop);
app.use(Modalbox);
app.use(Quote);
app.use(Employees);
app.use(Tickets);
app.use(FilteringActivites);
app.use(Filters);
app.use(VideoModal);
app.use(ImageSlider);
app.use(InfoboxesGrid);
app.use(LoadActivities);
app.use(NumbersLine);
app.use(MapPinSlider);
app.use(Tooltips)
Accordion()
app.use(MorningPopup)